import React from "react";
import ReactDOM from "react-dom";
import NewApp from "./NewApp";
import "./index.css";
// import * as serviceWorker from "./serviceWorker";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ReduxProvider from "./redux/provider";

const router = createBrowserRouter([
  {
    path: "/*",
    element: <NewApp />,
  },
]);

ReactDOM.render(
  <ReduxProvider>
    <RouterProvider router={router} />
  </ReduxProvider>,
  document.getElementById("root")
);

// serviceWorker.register();

// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     const swUrl = `${process.env.REACT_APP_PUBLIC_URL}/sw.js`;
//     navigator.serviceWorker
//       .register(swUrl)
//       .then((registration) => {
//         console.log("SW registered: ", registration);
//       })
//       .catch((registrationError) => {
//         console.log("SW registration failed: ", registrationError);
//       });
//   });
// }
